import NonResult from './NonResult';

export default NonResult;
